import axios from 'axios';
import castleService from '@/services/castle';

// Request interceptor to add Castle request token
axios.interceptors.request.use(
  async function (config) {
    try {
      const requestToken = await castleService.generateRequestToken();

      if (requestToken) {
        config.headers['Castle-Token'] = requestToken;
      }
    } catch (error) {
      console.warn(
        'Castle: Failed to add request token to axios request',
        error
      );
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  function (error) {
    if (
      error?.response?.status === 422 &&
      error?.response?.data?.error === 'castle denial'
    ) {
      window.location.href = `${window.location.origin}/broker/security`;
      return;
    }

    if (error?.response?.status === 401) {
      const pathname = window.location.pathname;

      // 'refresh_jwt' will always return 401 in Login and LoginCode,
      // if this is allowed, an infinite loop of reloads will be created.
      if (pathname.includes('login')) {
        return error;
      }
      if (pathname.includes('sign-up')) {
        return error;
      }
    } else if ([406].includes(error?.response?.status)) {
      // A Block by the server on the user.  They need to follow
      // the URL provided in the response
      window.location.replace(error?.response?.data?.url);
    }
    return error.response;
  }
);

export default axios;
